export const USERFLOW_MAX_RETRIES = 3;
export const USERFLOW_RETRY_DELAY = 2000; // 2 seconds between retries

export const LOAD_ERROR_MESSAGE = 'Could not load Userflow.js';
